export default __webpack_public_path__ + "static/media/laxmi.f87ac099.jpg";